<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

@if (!hideNav) {
  <lib-side-nav [selectedItem]="selectedItem" [navHeader]="navHeader" [items]="items"
  [appConfig]="appConfig"></lib-side-nav>
}
